'use client';

import { Instagram, Facebook, Linkedin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative bg-[#070709] border-t border-[#D4AF37]/15 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-4 gap-10 mb-12">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <div className="mb-5">
              <div className="font-display text-[#D4AF37] text-2xl font-semibold tracking-[0.18em]">
                MATAR
              </div>
              <div className="text-[11px] tracking-[0.4em] text-[#F4E8C1]/70 mt-1 font-light">
                STYLE CUIR
              </div>
            </div>
            <p className="text-sm text-[#F4E8C1]/55 leading-relaxed font-light max-w-md mb-6">
              Maison de cuir de luxe fondée à Anvers en 2014. Chaque pièce est
              façonnée à la main, numérotée, livrée avec certificat
              d'authenticité. Une maison Smartest Capital.
            </p>

            {/* Social */}
            <div className="flex gap-3">
              {[Instagram, Facebook, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="Réseau social"
                  className="w-10 h-10 flex items-center justify-center border border-[#D4AF37]/25 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#0a0a0f] transition-all duration-300"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Maison column */}
          <div>
            <h4 className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5 font-medium">
              La Maison
            </h4>
            <ul className="space-y-3">
              {[
                { href: '#atelier', label: 'L\'Atelier' },
                { href: '#a-propos', label: 'À Propos de la Maison' },
                { href: '#exception', label: 'Produits d\'Exception' },
                { href: '#sur-mesure', label: 'Sur Mesure' },
                { href: '#tracabilite', label: 'Traçabilité Blockchain' },
                { href: '#maison', label: 'Notre Histoire' },
                { href: '#heritage', label: 'Héritage Panafricain' },
                { href: '#usine-solaire', label: 'Usine Solaire Or' },
                { href: '#distinctions', label: 'Distinctions & Presse' },
                { href: '#temoignages', label: 'Témoignages Clients' },
                { href: '#chroniques', label: 'Chroniques de la Maison' },
                { href: '#faq', label: 'Questions Fréquentes' },
                { href: '#sur-invitation', label: 'Le Cercle MATAR' },
                { href: 'https://smartest-capital.org', label: 'Smartest Capital' },
                { href: 'https://asmao-style-cuir.smartest-capital.org', label: 'Asmao Style Cuir' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.href.startsWith('http') ? '_blank' : undefined}
                    rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                    className="text-sm text-[#F4E8C1]/55 hover:text-[#D4AF37] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Boutique column */}
          <div>
            <h4 className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5 font-medium">
              Boutique
            </h4>
            <ul className="space-y-3">
              {[
                { href: '#collections', label: 'Sacs & Maroquinerie' },
                { href: '#collections', label: 'Vestes & Prêt-à-porter' },
                { href: '#collections', label: 'Chaussures' },
                { href: '#collections', label: 'Ceintures & Petits Cuir' },
                { href: '#contact', label: 'Sur Mesure' },
              ].map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    className="text-sm text-[#F4E8C1]/55 hover:text-[#D4AF37] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Gold divider */}
        <div className="gold-divider mb-7" />

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-[10px] uppercase tracking-[0.25em] text-[#F4E8C1]/40">
          <p>© {new Date().getFullYear()} MATAR STYLE CUIR — Smartest Capital</p>
          <div className="flex items-center gap-4">
            <span className="text-[#D4AF37]">✦</span>
            <p>Anvers · Belgique</p>
            <span className="text-[#D4AF37]">✦</span>
            <p>Fait Main</p>
          </div>
          <div className="flex gap-4">
            <a href="#" className="hover:text-[#D4AF37] transition-colors">
              Mentions Légales
            </a>
            <a href="#" className="hover:text-[#D4AF37] transition-colors">
              Confidentialité
            </a>
          </div>
        </div>

        {/* Recommended by line */}
        <div className="mt-8 text-center text-[10px] uppercase tracking-[0.3em] text-[#F4E8C1]/30 italic">
          Recommandé par Son Altesse PapeNdiaw.Ndiaye.info
        </div>
      </div>
    </footer>
  );
}
